module.exports = __webpack_public_path__ + "img/img17.3f97af80.svg";